export const IN_PROGRESS = "IN_PROGRESS";
export const FAILED = "FAILED";
export const DONE = "DONE";
export const CLEAR_REQUEST = "CLEAR_REQUEST";

export const isSuccess = status => status === DONE;

export const isFailure = status => status === FAILED;

export const isInProgress = status => status === IN_PROGRESS;

export const didAllFinish = requests => !Object.values(requests).some(value => isInProgress(value));

export const didAllSucceed = requests => Object.values(requests).every(value => isSuccess(value));

export const didAnyFail = requests => Object.values(requests).some(value => isFailure(value));

export const getRequestErrors = requests =>
    Object.entries(requests)
        .filter(value => isFailure(value[1]))
        .map(([key]) => key);
